import React, { useCallback, useMemo, useState } from "react";
import Iconify from "../../../components/iconify";
import IconCode from "@/src/lib/iconCode";
import useCommon from "@/src/lib/util/useCommon";
import { centreApiService } from "@/src/lib/api-services/centreApiServices";
import Progressbar from "../../../components/loading";
import { useRouter } from "next/router";
import { useCustomQuery } from "@/src/lib/hooks/useFetch";
import CustomAccordion from "@/src/lib/ui/customAccordion";

const STATES = ["delhi", "uttar pradesh", "haryana", "maharashtra"];

const CentreSection = () => {
    const [cityId, setCityId] = useState(null);
    const { cityLists } = useCommon();

    const { data, isLoading } = useCustomQuery(
        ["city_centre_list", cityId],
        () => centreApiService.getCentreListById(cityId),
        {
            enabled: !!cityId,
        }
    );

    const filterCityByState = useCallback((data) => {
        if (!data) return {};

        return STATES.reduce((acc, stateName) => {
            acc[`${stateName.replace(" ", "")}Centre`] = data.filter(
                (state) => state.stateName?.toLowerCase() === stateName
            );
            return acc;
        }, {});
    }, []);

    const formatedCityList = useMemo(
        () => filterCityByState(cityLists),
        [cityLists, filterCityByState]
    );

    return (
        <>
            {/* On mobile: single column, on small screens: two columns, on medium screens and above: three columns */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2">
                <div>
                    <h4 className="font-semibold text-base mb-2 text-primary">
                        Delhi
                    </h4>

                    {formatedCityList?.delhiCentre?.map((city) => (
                        <AccordionSection
                            key={city?.cityId}
                            title={city.cityName}
                            id={city.cityId}
                        />
                    ))}
                </div>

                <div>
                    <h4 className="font-semibold text-base mb-2 text-primary">
                        Uttar Pradesh
                    </h4>
                    {formatedCityList?.uttarpradeshCentre?.map((city) => (
                        <AccordionSection
                            key={city?.cityId}
                            title={city.cityName}
                            id={city?.cityId}
                        />
                    ))}
                </div>
                <div>
                    <h4 className="font-semibold text-base mb-2 text-primary">
                        Haryana
                    </h4>
                    {formatedCityList?.haryanaCentre?.map((city) => (
                        <AccordionSection
                            key={city?.cityId}
                            title={city.cityName}
                            id={city?.cityId}
                        />
                    ))}
                </div>

                         <div>
                    <h4 className="font-semibold text-base mb-2 text-primary">
                        Maharashtra
                    </h4>
                    {formatedCityList?.maharashtraCentre?.map((city) => (
                        <AccordionSection
                            key={city?.cityId}
                            title={city.cityName}
                            id={city?.cityId}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

export default CentreSection;

const AccordionSection = ({ title, id }) => {
    const [expanded, setExpanded] = useState(false);
    const [open, setOpen] = useState(false);
    const router = useRouter();
    const frontendUrl = process.env.NEXT_PUBLIC_FRONTEND_URL;

    const handleToggle = (id) => {
        setOpen((prev) => !prev);
        setExpanded(id);
    };

    const { data: cityCentreList, isLoading: isFetchingCityCentreList } =
        useCustomQuery(
            ["city_centre_list", expanded],
            () => centreApiService.getCentreListById(expanded),
            {
                enabled: !!expanded,
            }
        );

    const centreList = useMemo(
        () => cityCentreList?.data?.centreData || [],
        [cityCentreList]
    );

    const navigateToCentre = (url) => {
        if (url) {
            router.push(`${frontendUrl}/${url}`);
        }
    };

    return (
        <CustomAccordion
            title={title}
            defaultExpanded={false}
            buttonClassName="rounded-none hover:bg-gray-100 font-bold md:text-sm text-xs py-2 hover:bg-transparent"
            className="border-b rounded-none"
            iconClassName="w-4 h-4"
            open={open}
            onClick={() => handleToggle(id)}
        >
            <div className="!p-0">
                {isFetchingCityCentreList ? (
                    <div className="flex justify-center flex-row">
                        <Progressbar size={20} />
                    </div>
                ) : (
                    centreList.map((centre) => (
                        <p
                            key={centre?.name}
                            onClick={() => navigateToCentre(centre?.url)}
                            className="text-black text-xs py-1.5 hover:text-primary cursor-pointer"
                        >
                            {centre.name}
                        </p>
                    ))
                )}
            </div>
        </CustomAccordion>
    );
};
